import { render, staticRenderFns } from "./DisposerImport.vue?vue&type=template&id=4f80f985&scoped=true&"
import script from "./DisposerImport.vue?vue&type=script&lang=js&"
export * from "./DisposerImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f80f985",
  null
  
)

export default component.exports